import { mapGetters } from "vuex"
import Config from '@/thirdParty/config' 
import { CommonService } from '@/services/common.service'
export default {
  data () {
    return {
      Config,
      loadingMx: false,
      dataUser: JSON.parse(localStorage.getItem('userData')) ?? {}
    }
  },
  mounted () {
    this.$root.$on('bv::modal::hide', bvEvent => {
      if (bvEvent.componentId === 'rejectMx' && bvEvent.trigger === 'ok' && this.$refs.rejectValue) {
        if (!this.$refs.rejectValue.value.trim()) {
          this.showFailMx('Lý do nhập không được bỏ trống', false)
          bvEvent.preventDefault()
        }
      }
    })
    this.$root.$on('bv::modal::hide', bvEvent => {
      if (bvEvent.componentId === 'rejectDeviceMx' && bvEvent.trigger === 'ok' && this.$refs.rejectValue) {
        if (!this.$refs.rejectValue.value.trim()) {
          this.showFailMx('Lý do thất lạc không được bỏ trống', false)
          bvEvent.preventDefault()
        } else if (this.$refs.rejectValue.value.trim().length > 1000) {
          this.showFailMx('Lý do thất lạc chứa tối đa 1000 ký tự', false)
          bvEvent.preventDefault()
        }
      }
    })
  },
  computed: {
    ...mapGetters({
      dataPermission: 'role/dataPermission',
    })
  },
  watch: {
    loadingMx (val) {
      this.$root.loadingMx = val
    }
  },
  methods: {
    async getProvinceMx(params = {}) {
      const provinceRes = await CommonService.getProvince(params)
      if (provinceRes.success) {
        return provinceRes.data.map(s => ({ id: s.code, text: s.name }))
      }
      return []
    },
    async getDistrictMx(params = {}) {
      const districtRes = await CommonService.getDistrict(params)
      if (districtRes.success) {
        return districtRes.data.map(s => ({ id: s.code, text: s.name }))
      }
      return []
    },
    async getWardMx(params = {}) {
      const response = await CommonService.getWard(params)
      if (response.success) {
        return response.data.map(s => ({ id: s.code, text: s.name }))
      }
      return []
    },
    async getBankMx(params = {}) {
      const bankRes = await CommonService.getBank(params)
      if (bankRes.success) {
        return bankRes.data.map(s => ({ id: s.id, text: s.bankName }))
      }
      return []
    },
    
    async getConfigMx() {
      const configRes = await CommonService.getConfigSystem()
      if (configRes.success) {
        return configRes.data
      }
      return {}
    },

    canAccessMx(...roles) {
      return !!roles.find(role => this.dataPermission.includes(role))
    },
    approveMx (message) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        message
      )
      return this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true
        })
    },
    rejectMx (title = 'Lý do từ chối', value = '') {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' , domProps: { value }})
      ])
      return this.$bvModal
        .msgBoxConfirm([messageVNode], {
          id: 'rejectMx',
          title: title,
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false
        })
        .then(async value => {
          return {
            value,
            note: this.$refs.rejectValue.value
          }
        })
    },
    rejectDeviceMx (title = 'Lý do từ chối') {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' })
      ])
      return this.$bvModal
        .msgBoxConfirm([messageVNode], {
          id: 'rejectDeviceMx',
          title: title,
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false
        })
        .then(async value => {
          return {
            value,
            note: this.$refs.rejectValue.value
          }
        })
    },
    showMsgMx (msgNoti, flag, createElement) {
      const h = this.$createElement
      const titleVNode = h('div', {
        domProps: { innerHTML: 'Thông báo' }
      })
      const messageVNode = h('div', { class: ['text-center'] }, [
        h('b-img', {
          props: {
            src: require(flag === true ? '@/assets/img/noti-success2.svg' : '@/assets/img/noti-unsuccess2.svg')
          }
        }),
        createElement 
            ? h('div', { class: ['f18 py-3 text-center'] }, [msgNoti, createElement])
            : h('div', { class: ['f18 py-3 text-center'], domProps: { innerHTML: msgNoti } })
      ])
      return {
        titleVNode,
        messageVNode
      }
    },
    showSuccessMx (msgNoti, createElement = null ) {
      const { titleVNode, messageVNode } = this.showMsgMx(msgNoti, true, createElement )
      return this.$bvModal.msgBoxOk([messageVNode], {
        title: [titleVNode],
        centered: true,
        okTitle: 'Đóng',
        okVariant: 'light'
      })
    },
    showFailMx (msgNoti, createElement = null) {
      const { titleVNode, messageVNode } = this.showMsgMx(msgNoti, false, createElement)
      return this.$bvModal.msgBoxOk([messageVNode], {
        title: [titleVNode],
        centered: true,
        okTitle: 'Đóng',
        okVariant: 'light'
      })
    },
    showModalComponentMx (title, cpn) {
      const component = this.$createElement(cpn.name, { props: cpn.props });
      return this.$bvModal.msgBoxOk([component], {
        title,
        id: cpn.id,
        centered: true,
        size: cpn.size ?? 'lg',
        hideFooter: true,
        footerClass: cpn.footerClass ?? ''
      })
    },
    async sendFileMx (item, type = 'image', folderName = 'NextAgent') {
      if (item && item.file && item.status !== 'uploaded') {
        const formData = new FormData()
        formData.append('files', item.file)
        formData.append('folderName', folderName)
        try {
          let data
          if (type === 'video' || type === 'pdf') {
            // data = await ContractService.uploadFileS3PDF(formData)
            data = await CommonService.uploadImage(formData)
          } else {
            data = await CommonService.uploadImage(formData)
          }
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return urlFile
        } catch (error) {
          this.showFailMx(error.message ?? error)
        }
      } else return item?.url ?? item
    },
  }
}
